import { useState, useEffect } from 'react';

/**
 * Custom hook to detect which section is currently in the viewport
 * @param {string[]} sectionIds - Array of section IDs to observe
 * @param {number} offset - Offset from top to trigger active state
 * @returns {string} - The currently active section ID
 */
export function useActiveSection(sectionIds, offset = 100) {
    const [activeSection, setActiveSection] = useState('');

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + offset;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            // Check if we're at the bottom of the page
            // If so, highlight the last section (Contact)
            const isAtBottom = window.scrollY + windowHeight >= documentHeight - 50;

            if (isAtBottom && sectionIds.length > 0) {
                // Get the last valid section that exists in the DOM
                for (let i = sectionIds.length - 1; i >= 0; i--) {
                    const element = document.getElementById(sectionIds[i]);
                    if (element) {
                        setActiveSection(sectionIds[i]);
                        return;
                    }
                }
            }

            // Normal scroll-based detection
            for (const sectionId of sectionIds) {
                const element = document.getElementById(sectionId);
                if (element) {
                    const { offsetTop, offsetHeight } = element;
                    if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
                        setActiveSection(sectionId);
                        return;
                    }
                }
            }
        };

        // Initial check
        handleScroll();

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [sectionIds, offset]);

    return activeSection;
}

export default useActiveSection;
